import React from 'react';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import { styles } from './PdfStyles';
import { 
    PdfHeader, 
    PdfMeta, 
    PdfDataTable, 
    PdfAssignmentCardShort, 
    PdfAssignmentCardLong, 
    PdfSignatures,
    PdfResourceOverview
} from './PdfElements';

/**
 * LeaderPdfDocument - Das Haupt-Dokument für den PDF-Export.
 */
export default function LeaderPdfDocument({ 
    assignments = [], 
    workers = [], 
    vehicles = [], 
    kolonnen = [],
    options = {}, 
    companyName, 
    userName, 
    dateRange,
    dateMode,
    exportDate = new Date().toLocaleString('de-DE'), // Fallback
    companyLoc: passedCompanyLoc = {}
}) {
    const companyLoc = passedCompanyLoc || {};
    // Sicherstellen, dass exportDate ein String ist
    const safeExportDate = String(exportDate || '');

    return (
        <Document title={`Arbeitsbericht_${safeExportDate.split(',')[0]}`}>
            <Page size="A4" style={styles.page}>
                {/* 1. Header & Meta */}
                <PdfHeader companyName={companyName} userName={userName} exportDate={safeExportDate} />
                <PdfMeta 
                    dateRange={dateRange} 
                    dateMode={dateMode} 
                    assignmentCount={assignments.length} 
                    exportStyle={options.exportStyle}
                />

                {/* 2. Ressourcen-Struktur (Vorblätter) */}
                <PdfResourceOverview 
                    kolonnen={kolonnen} 
                    workers={workers} 
                    vehicles={vehicles} 
                    options={options}
                />

                {/* 5. Einsätze (Immer, falls vorhanden) */}
                {assignments.length > 0 && (
                    <View>
                        <Text style={styles.sectionTitle}>Einsatzdetails ({assignments.length})</Text>
                        {assignments.map((a, i) => (
                            options.exportStyle === 'detailed' ? (
                                <PdfAssignmentCardLong key={i} assignment={a} options={options} companyLoc={companyLoc} kolonnen={kolonnen} />
                            ) : (
                                <PdfAssignmentCardShort key={i} assignment={a} options={options} companyLoc={companyLoc} kolonnen={kolonnen} />
                            )
                        ))}
                    </View>
                )}

                {/* 6. Unterschriften (Optional) */}
                {options.showSignatures && <PdfSignatures />}

                {/* 7. Footer */}
                <View style={styles.footer} fixed>
                    <Text>{companyName || 'Firma'} – Bericht vom {safeExportDate.split(',')[0]}</Text>
                    <Text render={({ pageNumber, totalPages }) => `Seite ${pageNumber} / ${totalPages}`} />
                </View>
            </Page>
        </Document>
    );
}
